import React, { FC } from 'react'
import { ITopicVersion } from '../types'
import Spinner from '../../../components/common/spinner/Spinner'
import UserDetail from '../../../components/common/user/user-detail/UserDetail'
import IconLayers from '../../../components/common/icon/IconLayers'
import IconLock from '../../../components/common/icon/IconLock'
import './Item.less'

interface IProps {
  topicVersion: ITopicVersion
  isLoading: boolean
  removeButton: JSX.Element
  DragHandle: React.ComponentClass
  fixedOrder: boolean
}

export const PathwayResourceListItem: FC<IProps> = (props: IProps) => {
  const { isLoading, topicVersion, removeButton, DragHandle, fixedOrder } =
    props
  const author = topicVersion.topic.author
  const workspace = topicVersion.topic.workspace

  return (
    <div className="ListItem Pathway__topic">
      {fixedOrder && (
        <div className="Pathway__topic-handle">
          <div className={'circle'} />
        </div>
      )}
      <h3 className="Pathway__topic-title">{topicVersion.title}</h3>
      <div className="Pathway__topic-workspace">
        <span className="Pathway__topic-workspace-icon">
          <IconLayers />
          {!workspace.is_open && <IconLock />}
        </span>
        {workspace.name}
      </div>
      <div className="Pathway__topic-user">
        <UserDetail
          display_name={author.display_name}
          imageUrl={author.image_url}
          size="small"
        />
      </div>
      {isLoading ? (
        <div className="Pathway__topic-loading">
          <Spinner />
        </div>
      ) : (
        <>
          <div className="Pathway__topic-controls">{removeButton}</div>
          <div className="Pathway__topic-reorder">
            <DragHandle />
          </div>
        </>
      )}
    </div>
  )
}
